import ResourceSelectField from './ResourceSelectField';

export default ResourceSelectField;
